import { RefObject, useEffect, useRef, useState } from "react";

export function useIntersectionObserver<T extends Element>(
  options?: IntersectionObserverInit,
  enabled = true
): [RefObject<T>, boolean] {
  const elementRef = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  const { root, rootMargin, threshold } = options || {};

  useEffect(() => {
    const node = elementRef.current;

    if (!node || !enabled) {
      setIsVisible(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { root, rootMargin, threshold }
    );

    observer.observe(node);

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [elementRef, root, rootMargin, threshold, enabled]);

  return [elementRef, isVisible];
}
